<template>
	<div>
		<div class="lg:flex">
			<div class="lg:w-1/2 flex"></div>
			<div class="lg:w-1/2 flex justify-end">
				<ButtonBlack>
					<router-link
						:to="'/admin/' + section"
						class="text-white no-underline"
					>
						<div class="flex items-center">
							<img src="@/assets/img/nuevo-mas.svg" alt="Nuevo" />
							<span>{{ $t('new') }}</span>
						</div>
					</router-link>
				</ButtonBlack>
			</div>
		</div>
		<ListTable
			:itemsTitles="itemsTitles"
			:items="links"
			:section="section"
			:itemsTable="itemsTable"
		/>
	</div>
</template>

<script>
import ListTable from '@/components/ListTable'
import gql from 'graphql-tag'

export default {
	apollo: {
		links: {
			query: gql`
				{
					links(order_by: { order: asc }) {
						id
						link_name
						country {
							code
						}
						link_url
						order
						publishing_date
						active
					}
				}
			`,
			update(data) {
				return data.links.map(item => ({
					id: item.id,
					name: item.link_name,
					countryCode: item.country.code,
					link: item.link_url,
					date: this.$moment(item.publishing_date).format('DD-MM-YYYY'),
					order: item.order,
					edit: true,
					active: item.active
				}))
			}
		}
	},
	data() {
		return {
			section: 'links',
			itemsTable: 'links',
			itemsTitles: ['Id', 'Nombre', 'Pais', 'Url', 'date', 'Orden']
		}
	},
	components: { ListTable }
}
</script>
